import React, {useState, useEffect} from "react";
import Loading from "../../Component/Loading/Loading";
import NavBar from "../../Component/NavBar/NavBar";
import {BiSolidUserDetail} from "react-icons/bi";
import {IoCheckboxOutline} from "react-icons/io5";
import apiRequests from "../../Component/axios/config/config";
import {useNavigate} from "react-router-dom";
import { PiSelectionAllFill } from "react-icons/pi";
import toast from "react-hot-toast";
import {IoIosAddCircleOutline} from "react-icons/io";



export default function Comment() {


    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");

    const [loading, setLoading] = useState(true);

    const [selectedComments, setSelectedComments] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const [showVerifyModal, setShowVerifyModal] = useState(false);

    const [commentData, setCommentData] = useState([])
    const [commentId, setCommentId] = useState({
        id: "",
        verify: ""
    });

    const allSelectedAreUnverified = selectedComments.length > 0 &&
        selectedComments.every(id => {
            const comment = commentData.find(item => item._id === id);
            return comment && !comment.is_verified;
        });
    const allSelectedAreVerified = selectedComments.length > 0 &&
        selectedComments.every(id => {
            const comment = commentData.find(item => item._id === id);
            return comment && comment.is_verified;
        });

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    function GetApi(page = currentPage) {
        setLoading(true);
        const params = {
            page: page,
            limit: 10,
        };

        if (searchQuery) {
            params.search = searchQuery;
        }
        apiRequests.get('/api/comment/get-all-admin', {params})
            .then((res) => {
                setCommentData(res.data.data.commentList.data);
                setTotalPages(res.data.data.commentList.totalCount);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setLoading(false));
    }


    useEffect(() => {
        GetApi(currentPage);
    }, [currentPage, searchQuery]);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    function verifiedComment(id, verify) {
        setShowVerifyModal(true)
        setCommentId({
            id: id,
            verify: verify
        })
    }

    function toggleSelectAll() {
        if (selectAll) {
            setSelectedComments([]);
        } else {
            setSelectedComments(commentData.map(item => item._id));
        }
        setSelectAll(!selectAll);
    }



    function selectItem(idTarget) {
        if (selectedComments.includes(idTarget)) {
            setSelectedComments(prev => prev.filter(id => id !== idTarget));
        } else {
            setSelectedComments(prev => [...prev, idTarget]);

        }

    }

    async function saveSettings(settings) {
        const response = await apiRequests.post('/api/comment/verify', settings);
        if (response.data.status === 200) {
            GetApi()
            setSelectedComments([])
        }

        return response.data;
    }


    function verifiedSelected () {



        toast.promise(
            saveSettings(
                {
                    comments: selectedComments,
                    is_verified: true
                }
            ),
            {
                loading: 'loading ...',
                success: <b>Verify successfully</b>,
                error: <b>Verify field</b>,
            }
        );

    }

    function unverifiedSelected () {



        toast.promise(
            saveSettings(
                {
                    comments: selectedComments,
                    is_verified: false
                }
            ),
            {
                loading: 'loading ...',
                success: <b>unverify successfully</b>,
                error: <b>unverify field</b>,
            }
        );

    }



    return (
        <div className="p-6">

            <div className="text-3xl font-bold text-gray-800 mb-6">
                Comment Management
            </div>

            <NavBar
                item={[
                    {
                        icon: <PiSelectionAllFill style={{ fontSize: "22px" }} />,
                        title: "Select All",
                        onClick: toggleSelectAll
                    },
                    ...(allSelectedAreUnverified ? [
                        {
                            icon: <IoCheckboxOutline style={{ fontSize: "22px" }} />,
                            title: "Verify Selected",
                            onClick: verifiedSelected
                        }
                    ] : []),
                    ...(allSelectedAreVerified ? [
                        {
                            icon: <IoCheckboxOutline style={{ fontSize: "22px" }} />,
                            title: "unverify Selected",
                            onClick: unverifiedSelected
                        }
                    ] : [])
                ]}
                onSearch={(value) => {
                    setSearchQuery(value);
                    setCurrentPage(1);
                }}
            />

            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                        <thead
                            className="bg-gradient-to-r text-left from-amber-600 to-blue-600 text-white">
                        <tr>
                            <th className="px-4 py-2 text-md font-medium rounded-tl-lg w-2"></th>
                            <th className="px-4 py-2 text-md font-medium">Title</th>
                            <th className="px-4 py-2 text-md font-medium">Product</th>
                            <th className="px-4 py-2 text-md font-medium">User Name</th>
                            <th className="px-4 py-2 text-md font-medium">Create At</th>
                            <th className="px-4 py-2 text-md font-medium rounded-tr-lg">Status</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {loading ?
                            <tr>
                                <td className="px-4 py-3 text-center" colSpan="5">
                                    <Loading/>
                                </td>
                            </tr>
                            :
                            commentData?.length > 0 ?
                                commentData.map((item) =>
                                    <tr key={item._id}>
                                        <td className="px-4 py-2 text-md font-medium rounded-tl-lg w-2">
                                            <input
                                                type="checkbox"
                                                checked={selectedComments.includes(item._id)}
                                                onChange={() => selectItem(item._id)}
                                            />

                                        </td>
                                        <td className="px-4 py-2 text-md font-medium">
                                            {item.content || "-"}
                                        </td>
                                        <td onClick={() => navigate(`/product/${item.product[0]._id}`)}
                                            className="px-4 py-2 hover:cursor-pointer text-md font-medium">
                                            {item.product[0].name}
                                        </td>
                                        <td className="px-4 py-2 text-md font-medium">
                                            {item.author[0].userName}
                                        </td>

                                        <td className="px-4 py-2 text-md font-medium">
                                            {new Date(item.updatedAt).toLocaleDateString("en")}
                                        </td>
                                        <td className={`px-4 py-4`}>
                                        <span className={`px-2 hover:cursor-pointer py-1 rounded-full text-xs font-medium 
                                            ${!item.is_verified ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}
                                              onClick={() => verifiedComment(item._id, item.is_verified)}

                                        >
                                            {item.is_verified ?
                                                'verified'
                                                :
                                                'not verified'}
                                        </span>
                                        </td>

                                    </tr>
                                )
                                :
                                <tr className="">
                                    <td className="px-4 py-3 text-center" colSpan="5">Comment not found!</td>
                                </tr>
                        }


                        </tbody>
                    </table>
                </div>
            </div>

            <div className="flex justify-center items-center mt-6 space-x-2">
                <button
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                    className={`px-3 py-1 rounded-md border ${
                        currentPage === 1 ? "text-gray-400 border-gray-200" : "text-blue-600 border-blue-400 hover:bg-blue-100"
                    }`}
                >
                    Prev
                </button>

                <span className="px-4">
                    Page {currentPage} of {totalPages}
                </span>

                <button
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                    className={`px-3 py-1 rounded-md border ${
                        currentPage === totalPages ? "text-gray-400 border-gray-200" : "text-blue-600 border-blue-400 hover:bg-blue-100"
                    }`}
                >
                    Next
                </button>
            </div>

            {showVerifyModal &&
                <ModalVerify setShow={setShowVerifyModal} apiGet={GetApi} StatusVerify={commentId.verify}
                             id={commentId.id}/>}

        </div>
    )
}


export function ModalVerify({setShow, apiGet, StatusVerify, id}) {

    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();
    function verifyComment() {

        setLoading(true)
        apiRequests.post(`/api/comment/verify`, {
            comments: [id],
            is_verified: !StatusVerify
        })
            .then(() => {
                apiGet()
                setShow(false)
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (

        <div className="report-modal fixed inset-0 bg-black bg-opacity-60 md:overflow-y-auto transition-opacity">
            <div className="flex min-h-full items-end justify-center p-3 text-center">
                <div
                    className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-fit m-auto flex flex-col">

                    <div
                        className="flex md:flex md:flex-col font-bold text-lg auto-cols-auto gap-6 text-gray-500  justify-center">

                        {StatusVerify ?
                            "Do you want to disapprove this comment ?"
                            :
                            "Do You Want Verify This Comment ?"
                        }

                    </div>

                    <div className="flex justify-center items-center gap-5 mt-8">

                        <button
                            className={`px-6 py-1 border-2
                            ${!StatusVerify ? `text-white bg-buttonColor-shade6 border-buttonColor-shade6` : `text-white bg-red-700 border-red-600`}
                              font-bold  rounded-lg 
                             `}
                            onClick={verifyComment}
                            disabled={loading}
                        >
                            {loading ?
                                <Loading textColor={`white-0`}/>
                                :
                                StatusVerify ?
                                    "Disapprove"
                                    :
                                    "Verify"

                            }
                        </button>

                        <button
                            className="border-marginColor-shade6 hover:bg-marginColor-shade6 hover:text-white border-2 px-4 py-1 rounded-lg"
                            onClick={() => setShow(false)}>
                            Cancel
                        </button>

                    </div>
                </div>
            </div>
        </div>

    )
}